// Shared Avengers theme — single source of truth
export const A = {
  primary: '#7b68ee', accent: '#e429f2', gold: '#ffd300',
  surfaceCard: 'rgba(30,25,60,0.35)',
  surfaceModal: 'rgba(15,12,35,0.98)',
  border: 'rgba(123,104,238,0.15)',
  text: '#eee8ff',
  dim: 'rgba(220,210,255,0.55)',
  surface: 'rgba(12,16,35,0.8)',
};

export const TYPE_COLORS = {
  exam: '#ef4444', class: '#3b82f6', assignment: '#f59e0b', lab: '#8b5cf6',
  meeting: '#10b981', deadline: '#f97316', reminder: '#6366f1', event: '#ec4899', other: '#6b7280',
};

export const CAT_COLORS = {
  personal: '#3b82f6', contact: '#10b981', credentials: '#f59e0b', academic: '#8b5cf6', other: '#6b7280',
};

// Shared styles
export const inputStyle = { padding:'9px 12px', borderRadius:'6px', border:`1px solid ${A.border}`, background:'rgba(123,104,238,0.04)', color:A.text, WebkitTextFillColor:A.text, fontSize:'16px', outline:'none', colorScheme:'dark' };
export const btnStyle = { padding:'8px 16px', borderRadius:'6px', border:`1px solid ${A.border}`, cursor:'pointer', background:'rgba(123,104,238,0.08)', color:A.primary, fontSize:'12px', fontWeight:600, letterSpacing:'0.5px' };
export const iconBtnStyle = { padding:'8px 10px', borderRadius:'6px', border:'none', cursor:'pointer', background:'rgba(255,255,255,0.04)', color:A.dim, fontSize:'13px', transition:'background 0.15s, color 0.15s', minWidth:'44px', minHeight:'44px', display:'flex', alignItems:'center', justifyContent:'center' };
export const modalInputStyle = { padding:'10px 14px', borderRadius:'6px', border:`1px solid ${A.border}`, background:'rgba(123,104,238,0.04)', color:A.text, WebkitTextFillColor:A.text, fontSize:'16px', outline:'none', colorScheme:'dark' };
export const btnCancel = { padding:'8px 18px', borderRadius:'6px', border:'1px solid rgba(255,255,255,0.08)', background:'rgba(255,255,255,0.03)', color:A.dim, fontSize:'11px', fontWeight:700, cursor:'pointer', letterSpacing:'1px' };
export const btnSave = { padding:'8px 18px', borderRadius:'6px', border:'1px solid rgba(123,104,238,0.3)', background:`linear-gradient(135deg,rgba(123,104,238,0.2),rgba(228,41,242,0.1))`, color:A.primary, fontSize:'11px', fontWeight:700, cursor:'pointer', letterSpacing:'1px', boxShadow:'0 0 10px rgba(123,104,238,0.1)' };
